/* ==========================================================================
   SearcherFli > Client > Options
   ========================================================================== */

/* Modules */
const Checkbox = require('@bluekiri/alexandria-contrib-components/components/checkbox-rxjs/client/js');

/* eslint-disable */
const CheckboxActions = require('@bluekiri/alexandria-contrib-components/components/checkbox-rxjs/client/js/store/actions');
/* eslint-enable */

const { actions } = require('../store/actions');

const configuration = require('../config');

/* Init */
function initOptions(instance) {
    const panel = instance;

    /* Selector */
    const { selector } = instance;

    const checkboxes = [
        ...instance.element.querySelectorAll(
            `${selector} [data-component='CheckboxRxjs'][data-type^='${configuration().type.options}']`
        )
    ];

    if (checkboxes.length === 0) return;

    /* Reference */
    panel.options = checkboxes.map(item =>
        Checkbox(`${selector} [data-component='CheckboxRxjs'][data-type='${item.dataset.type}']`)
    );

    /* Actions */
    panel.actions = {
        ...instance.actions,
        changeOptions: payload => {
            return instance.store.dispatch(actions.changeOptions(payload));
        }
    };

    /* Checkbox references */
    const { options } = instance.config;
    panel.checkboxReferences = [];

    /* Reactions */
    panel.options.forEach((item, index) => {
        panel.checkboxReferences.push({ name: options[index].name, id: index, unchecks: options[index].unchecks });

        panel.reactions = {
            ...instance.reactions,
            [`changeOptions${index}`]: item.store.subscribe((state, action) => {
                if (action.type !== CheckboxActions.types.TOGGLE) return;

                const previousOptions = instance.store.select('data').options;

                /* Uncheck options */
                if (panel.checkboxReferences[index].unchecks) {
                    panel.checkboxReferences
                        .filter(x => panel.checkboxReferences[index].unchecks.indexOf(x.name) >= 0)
                        .forEach(x => {
                            const checked = previousOptions[x.id];

                            if (checked) {
                                panel.options[x.id].hooks.input.checked = false;
                                panel.options[x.id].actions.toggle();
                            }
                        });
                }

                /* Get new values form all options */
                const values = instance.options.map(itm => itm.store.select('checkbox').checked);

                /* Dispatch */
                instance.actions.changeOptions(values);
            })
        };
    });

    /* Start */
    const values = instance.options.map(item => item.store.select('checkbox').checked);

    if (!values) {
        return;
    }

    /* Sync */
    instance.actions.setSearcher({ options: values });
}

/* Destroy */
function destroyOptions(instance) {
    if (!instance.options) return;

    const panel = instance;

    /* Actions */
    delete panel.actions.changeOptions;

    /* Reactions */
    instance.options.forEach((item, index) => delete panel.reactions[`changeOptions${index}`]);

    /* Checkbox references */
    delete panel.checkboxReferences;

    /* Reference */
    instance.options.forEach(item => item.actions.destroy());
    delete panel.options;
}

/* Exports */
module.exports = {
    initOptions,
    destroyOptions
};
